module.exports = __webpack_public_path__ + "img/drawer_rebate_active.d4299a01.svg";